module.exports = __webpack_public_path__ + "static/media/myBackHead.5aca9eae.jpg";